/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlSortCriteria {
    getFixupPrototypeFunction() { return ComplianceControlSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlSortCriteria>): ComplianceControlSortCriteria {
        let obj = Object.assign(new ComplianceControlSortCriteria(), model);
        ComplianceControlSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlSortCriteria>): ComplianceControlSortCriteria {
        if (!model) return null;
        return ComplianceControlSortCriteria.newInstance(<ComplianceControlSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlSortCriteria) {
        if (!obj) return;

        models.ComplianceControlSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlSortCriteria): boolean {
        Object.setPrototypeOf(obj, ComplianceControlSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ComplianceControlSortColumn;

    ascending: boolean;

}
